

















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit, Watch } from "vue-property-decorator";
import { PaginationPlugin } from "bootstrap-vue";
import { SportEvent } from "@/models";
import AppSportEventListItem from "./AppSportEventListItem.vue";

Vue.use(PaginationPlugin);

@Component({
  name: "AppSportEventList",
  components: { AppSportEventListItem },
  data() {
    return {
      currentPage: 1
    };
  }
})
export default class AppSportEventList extends Vue {
  @Prop() sportEvents!: SportEvent[];
  @Prop({ default: 3 }) columns!: number;
  @Prop({ default: true }) pagination!: boolean;
  @Prop() total!: number;
  @Prop() perPage!: number;

  @Watch("currentPage")
  onCurrentPageChanged(newCurrentPage: number) {
    this.$emit("paged", newCurrentPage);
  }
}
